// src/redux/actions/siteActions.js
// This is a action type constant , why? avoid typo mistakes
export const SET_FEATURE_ACCESS = 'SET_FEATURE_ACCESS';

// Action Creator
// This creates action object.
export const setFeatureaccess = (featureaccess) => ({
  type: SET_FEATURE_ACCESS,
  payload: featureaccess,
});

/*
if called like setFeatureaccess(["ADMIN","USER"])

It returns =>
{
type: SET_FEATURE_ACCESS,
payload:  ["ADMIN", "USER"]
  }
THIS object goes to reducer 


*/